import { render, staticRenderFns } from "./InvoiceHistoryCard.vue?vue&type=template&id=1d525bc8"
import script from "./InvoiceHistoryCard.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports